/**
 * useStores
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react';
import StoresContext from './stores-context';

const useStores = () => {
  const context = useContext(StoresContext);
  return context
};

export default useStores;
